import { Box, List, ListItem, ListItemText } from "@mui/material";
import moment from "moment";
import React from "react";

const HireDate = ({ params }) => {
	return (
		<>
			<Box
				sx={{
					width: "100%",
					display: "grid",
					placeItems: "center",
					alignItems: "center",
					alignContent: "center",
					gap: "10px",
					p: 1.5,
					height: "100%",
				}}
			>
				<List sx={{ width: "100%" }} dense={true}>
					{params?.value?.map((orgpath) => (
						<ListItem key={orgpath.hiring_orgpath_id}>
							<ListItemText
								primary={`${moment(
									orgpath.Range.start_date
								).format("DD/MM/YYYY")} - ${moment(
									orgpath.Range.end_date
								).format("DD/MM/YYYY")}`}
							/>
						</ListItem>
					))}
				</List>
			</Box>
		</>
	);
};

export { HireDate };
